import React, { useEffect, useState, createElement } from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { AboutSection } from './components/AboutSection';
import { GallerySection } from './components/GallerySection';
import { FeaturesSection } from './components/FeaturesSection';
import { LocationSection } from './components/LocationSection';
import { UnitsSection } from './components/UnitsSection';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
import { GalleryPage } from './pages/GalleryPage';
import { UnitsPage } from './pages/UnitsPage';
export function App() {
  const [currentPath, setCurrentPath] = useState(window.location.hash);
  // Google Analytics (gtag.js)
  useEffect(() => {
    // Initialize dataLayer
    const w = window as any;
    w.dataLayer = w.dataLayer || [];
    w.gtag = function () {
      w.dataLayer.push(arguments);
    };
    w.gtag('js', new Date());
    w.gtag('config', 'G-X0FP2EDPSF');
    // Load gtag.js script
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=G-X0FP2EDPSF';
    document.head.appendChild(script);
  }, []);
  useEffect(() => {
    const handleHashChange = () => {
      setCurrentPath(window.location.hash);
    };
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);
  // Route to GalleryPage
  if (currentPath.startsWith('#cela-galerie')) {
    return <GalleryPage data-id="element-0" />;
  }
  // Route to UnitsPage
  if (currentPath.startsWith('#nabidka-bytu')) {
    return <UnitsPage data-id="element-1" />;
  }
  return <div className="min-h-screen bg-base-cream font-body text-base-dark" data-id="element-2">
      <Navbar data-id="element-3" />
      <main data-id="element-4">
        <HeroSection data-id="element-5" />
        <AboutSection data-id="element-6" />
        <GallerySection data-id="element-7" />
        <FeaturesSection data-id="element-8" />
        <LocationSection data-id="element-9" />
        <UnitsSection data-id="element-10" />
        <ContactSection data-id="element-11" />
      </main>
      <Footer data-id="element-12" />
    </div>;
}